import type * as CSS from "csstype";

export interface IPagination {
  currentPage: number;
  totalPages: number;
  pageSize: number;
}

export enum ActionType {
  list = "list",
  add = "add",
  update = "update",
  delete = "delete",
}

export interface IStyles {
  [key: string]: React.CSSProperties;
}

export interface IValidationErrors {
  [key: string]: string;
}

export interface IFilterOption {
  label: string;
  value: string;
}

export type Order = "asc" | "desc";
export type Direction = "rtl" | "ltr";

export interface ICSS {
  [key: string]: CSS.Properties;
}

export interface IOption {
  label: string;
  value?: string | number | { year: number; month: string };
  avatar?: string;
}

export enum PeriodValue {
  ALL_YEAR = "ALL_YEAR",
  LAST_WEEK = "LAST_WEEK",
  JANUARY = "JANUARY",
  FEBRUARY = "FEBRUARY",
  MARCH = "MARCH",
  APRIL = "APRIL",
  MAY = "MAY",
  JUNE = "JUNE",
  JULY = "JULY",
  AUGUST = "AUGUST",
  SEPTEMBER = "SEPTEMBER",
  OCTOBER = "OCTOBER",
  NOVEMBER = "NOVEMBER",
  DECEMBER = "DECEMBER",
}
